import classNames from 'classnames';
import Txt from '../Txt';
import FlexContainer from '../FlexContainer';
import View from '../View';
import styles from './MarksOnLine.module.scss';

/**
 * MarksOnLine
 *
 * @return {JSX.Element}
 */
const MarksOnLine = ({ className, data, title, description }) => {
  return (
    <FlexContainer
      className={classNames(
        styles.MarksOnLine,
        className,
        `${MarksOnLine.displayName}`
      )}
      column
      gapHalf
    >
      {title || description ? (
        <FlexContainer alignCenter gap spaceBetween>
          {title ? <Txt bold>{title}</Txt> : null}
          {description ? <Txt bold>{description}</Txt> : null}
        </FlexContainer>
      ) : null}
      <View className={styles.Body}>
        {data.map((v) => (
          <View
            key={v}
            className={styles.Mark}
            style={{ left: `${v * 100}%` }}
          />
        ))}
      </View>
    </FlexContainer>
  );
};

MarksOnLine.displayName = 'MarksOnLine';

export default MarksOnLine;
